import { combineReducers } from 'redux';
import { ADD_FORM, ADD_PROJECT, ADD_SHEET, ADD_UPDATE_MUM, ADD_UPDATE_PA, EDIT_USAGE, NEW_FORM, NEW_SHEET, SET_DEVICE, SET_ID, SET_PROJECT, SET_TRIAL, SET_UNLICENSED, SET_USER, SHOW_WELCOME } from '../actions/index';

const initProduct = {
    myid: null,
    trial: 0,
    unlicensed: 0,
    devices: 0,
    show_welcome: false
}

function todoProduct(state = initProduct, action) {
    switch (action.type) {

        case SET_ID:
            return { ...state, myid: action.payload }
        case SET_TRIAL:
            return { ...state, trial: action.payload }
        case SET_UNLICENSED:
            return { ...state, unlicensed: action.payload }
        case SET_DEVICE:
            return { ...state, devices: action.payload }
        case SHOW_WELCOME:
            return { ...state, show_welcome: action.payload }

        default:
            return state;
    }
}
const ShopApp = combineReducers({
    _todoProduct: todoProduct
});

export default ShopApp;